import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { TalentCard } from "@/components/shared";

export default function Talents() {
  const [params, setParams] = useSearchParams();
  const service = params.get("service") || "";
  const [services, setServices] = useState([]);
  const [talents, setTalents] = useState(null);

  useEffect(() => { api.get("/services").then((r) => setServices(r.data)); }, []);
  useEffect(() => {
    setTalents(null);
    api.get("/talents", { params: service ? { service } : {} }).then((r) => setTalents(r.data));
  }, [service]);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-12 sm:py-16">
      <div className="flex flex-wrap gap-2"><span className="tag"><span className="tag-dot" style={{ background: "var(--mint)" }} />Terverifikasi</span><span className="tag"><span className="tag-dot" style={{ background: "var(--peach)" }} />18+</span></div>
      <h1 className="display mt-6 text-4xl sm:text-5xl lg:text-6xl text-neutral-900">Pilih teman<br />cerita kamu</h1>
      <p className="mt-5 text-neutral-600 max-w-xl leading-relaxed">Semua talent sudah kami wawancara dan verifikasi identitasnya. Status online diperbarui oleh talent sendiri.</p>
      <div className="mt-8 flex flex-wrap gap-2" data-testid="service-filter">
        <button onClick={() => setParams({})} className={`px-5 h-11 rounded-full text-sm border transition-colors duration-300 ${!service ? "bg-neutral-900 text-white border-neutral-900" : "bg-white border-neutral-300 text-neutral-700 hover:bg-neutral-50"}`} data-testid="filter-all">Semua</button>
        {services.map((s) => (
          <button key={s.id} onClick={() => setParams({ service: s.id })} className={`px-5 h-11 rounded-full text-sm border transition-colors duration-300 ${service === s.id ? "bg-neutral-900 text-white border-neutral-900" : "bg-white border-neutral-300 text-neutral-700 hover:bg-neutral-50"}`} data-testid={`filter-${s.id}`}>{s.name}</button>
        ))}
      </div>
      {talents === null ? (
        <p className="mt-10 text-neutral-500" data-testid="talents-loading">Memuat talent...</p>
      ) : talents.length === 0 ? (
        <p className="mt-10 text-neutral-500" data-testid="talents-empty">Belum ada talent untuk layanan ini.</p>
      ) : (
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-testid="talents-grid">
          {talents.map((t) => <TalentCard key={t.id} t={t} />)}
        </div>
      )}
    </div>
  );
}
